"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

require("core-js/modules/es6.regexp.split");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _uigBreakpoints = require("@sfly/uig-breakpoints");

require("../style.css");

var _Logger = _interopRequireDefault(require("../common/util/Logger"));

var _helperUtil = require("../common/util/helperUtil");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../constants");

var _uigCdnLibraries = require("@sfly/uig-cdn-libraries");

require("@sfly/uig-font-faces/montserratV2");

var _EyebrowPromo = _interopRequireDefault(require("../components/EyebrowPromo"));

var _SkipLinks = _interopRequireDefault(require("../components/SkipLinks"));

var _fetchEyebrowPromo2 = _interopRequireDefault(require("../common/fetchEyebrowPromo"));

var _fetchMyProjectData = _interopRequireDefault(require("../common/fetchMyProjectData"));

var _CategoryDataCache = _interopRequireDefault(require("../common/CategoryDataCache"));

var _SubNavWrapperMobile = _interopRequireDefault(require("./SubNavWrapperMobile"));

var _Hamburger = _interopRequireDefault(require("../components/Hamburger"));

var _HamburgerMenuComponent = _interopRequireDefault(require("../components/HamburgerMenuComponent"));

var _LogoTabs = _interopRequireDefault(require("../components/LogoTabs"));

var _PersonalToolbar = _interopRequireDefault(require("../components/PersonalToolbar"));

var _SubNavWrapper = _interopRequireDefault(require("./SubNavWrapper"));

require("./UniversalHeader.css");

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_construct.default) return false;
    if (_construct.default.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call((0, _construct.default)(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = (0, _construct.default)(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var loggerInstance = new _Logger.default('UniversalHeader');
var URL_SIGN_UP = "https://www.".concat((0, _helperUtil.getEnvPrefix)(), "shutterfly.com/signupconfirmation");

var UniversalHeader = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UniversalHeader, _Component);

  var _super = _createSuper2(UniversalHeader);

  function UniversalHeader(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UniversalHeader);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "markInfo", function (message) {
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date().toLocaleString();

      _this.logInfo.push((0, _defineProperty2.default)({}, message, time)); // this.logInfo.push({ [message+"_"+"inMilli"]: new Date().getTime() });

    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCategoriesFetchSuccess", function (categories) {
      if (_this.props.brandType === 'SFLY' || _this.props.brandType === 'TP') {
        var windowUrlPath = typeof window !== 'undefined' ? window.location.pathname : '';
        var windowUrlPathArr = typeof window !== 'undefined' ? windowUrlPath !== '/' && windowUrlPath.split('/') : '';

        if (windowUrlPathArr && windowUrlPathArr.length >= 2) {
          var selectCategoryCode = '';
          var curentUrlPath = "/".concat(windowUrlPath.split("/")[1]);
          categories && categories.some(function (cat) {
            /**
             * Case 1: Url check - beginning with category path -> (cat.url === curentUrlPath)
             * Case 2: Url check - category path name at the end of the url -> strEndsWith(curentUrlPath, cat.url.substr(1))
             * Case 3: Breadcrumb check - this.isCatSelectedByBreadcrumb(cat.url)
             */
            // 
            if (cat.url === curentUrlPath || cat.url === '/personalized-gifts' && curentUrlPath === '/photo-gifts' || (0, _helperUtil.strEndsWith)(curentUrlPath, cat.url.substr(1)) || _this.isCatSelectedByBreadcrumb(cat.url)) {
              selectCategoryCode = cat.code;
              return true;
            }
          });

          if (selectCategoryCode) {
            _this.setState({
              selectedCategoryId: selectCategoryCode
            });
          }
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isCatSelectedByBreadcrumb", function (url) {
      var linkQuery1 = "a[href=\"".concat(url, "\"]");
      var linkQuery2 = "a[href=\"".concat(url, "/\"]");
      var query = "#storeBreadcrumb ".concat(linkQuery1, ",#storeBreadcrumb ").concat(linkQuery2, ", .page-nav-text ").concat(linkQuery1, ", .page-nav-text ").concat(linkQuery2, ", .breadcrumb ").concat(linkQuery1, ", .breadcrumb ").concat(linkQuery2);
      var breadCrumbEle = typeof document !== 'undefined' && document.querySelector(query);
      return breadCrumbEle && url === breadCrumbEle.getAttribute('href');
    });
    _this.logInfo = [];
    var brandType = _this.props.brandType === '' || _constants.BRANDS.TINYPRINTS !== _this.props.brandType.trim().toUpperCase() ? _constants.BRANDS.SHUTTERFLY : _constants.BRANDS.TINYPRINTS;
    _this.categoryCache = new _CategoryDataCache.default({
      brandType: brandType,
      invalidCachedTimeCategories: props.invalidCachedTimeCategories,
      enableLocalStorageCached: props.enableLocalStorageCached,
      markInfo: function markInfo(str) {
        return _this.markInfo(str);
      },
      loggerInstance: loggerInstance,
      enableMockData: props.enableMockData,
      invalidCachedTimeSubnavConfig: props.invalidCachedTimeSubnavConfig
    });
    _this.state = {
      isOpen: false,
      selectedCategoryId: props.selectedCategoryId,
      gotCategoryCodefromWindowEvent: false,
      isSpoonflowerDayOneEnabled: false,
      eyebrowPromoData: {},
      brandType: _this.props.brandType === '' || _constants.BRANDS.TINYPRINTS !== _this.props.brandType.trim().toUpperCase() ? _constants.BRANDS.SHUTTERFLY : _constants.BRANDS.TINYPRINTS
    };
    _this.logInfo = [];
    _this.toggleMenu = _this.toggleMenu.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateSkipLinks = _this.updateSkipLinks.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleUHResizeMode = _this.handleUHResizeMode.bind((0, _assertThisInitialized2.default)(_this));

    _this.markInfo('Universal Header: Initilialized');

    _this.markInfo('Universal Header: Props =' + (0, _stringify.default)(_this.props));

    _this.skipLinks = _react.default.createRef();
    _this.isBackScreenFocusable = true;
    _this.handleHeaderKeyDown = _this.handleHeaderKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.focusHamburgerButton = _this.focusHamburgerButton.bind((0, _assertThisInitialized2.default)(_this));

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', _this.handleUHResizeMode);
    } // Add event listener for sflyAuth session expiration


    _this.handleSflySessionLogout = _this.handleSflySessionLogout.bind((0, _assertThisInitialized2.default)(_this));

    if (typeof document !== 'undefined') {
      document.addEventListener('sflySessionLogout', _this.handleSflySessionLogout);
    }

    return _this;
  }

  (0, _createClass2.default)(UniversalHeader, [{
    key: "componentDidCatch",
    value: function componentDidCatch() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var info = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      loggerInstance.error('Error: ', 'componentDidCatch', (0, _objectSpread3.default)({}, error, {}, info));
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this2 = this;

        var spoonflowerTag, isSpoonflowerDayOneEnabled, selectedCategoryId;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.markInfo('Universal Header: Mounted');
                spoonflowerTag = document.querySelector('meta[feature-flag][name="spoonflower_day1_enabled"]');
                isSpoonflowerDayOneEnabled = !!(spoonflowerTag && spoonflowerTag.getAttribute('content') === 'true');
                this.setState({
                  isSpoonflowerDayOneEnabled: isSpoonflowerDayOneEnabled
                });
                selectedCategoryId = this.state.selectedCategoryId;
                this.categoryCache.listenToCatalog(function (categories) {
                  var isValidSelectedCatId = false;

                  if (selectedCategoryId) {
                    isValidSelectedCatId = categories.some(function (cat) {
                      return cat.code === selectedCategoryId;
                    });
                  }

                  if (!selectedCategoryId || !isValidSelectedCatId) {
                    _this2.onCategoriesFetchSuccess(categories);
                  }
                });

                if (!this.props.hideToolbar) {
                  this.getCurrentUser();
                }

                this.updateSkipLinks();

                if (typeof document !== 'undefined' && document.readyState !== 'complete' && typeof window !== 'undefined') {
                  window.addEventListener('load', function (event) {
                    _this2.fetchEyebrowPromo(); //update the skip links once again at the end of event loop so that footer and main elements are rendered


                    setTimeout(_this2.updateSkipLinks, 0);
                  });
                } else {
                  this.fetchEyebrowPromo();
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event listener for sflyAuth session expiration
      if (typeof document !== 'undefined') {
        document.removeEventListener('sflySessionLogout', this.handleSflySessionLogout);
      }
    }
  }, {
    key: "handleSflySessionLogout",
    value: function handleSflySessionLogout() {
      // Sync up the logged in state if a user logs out on another tab
      if (this.state.user || this.state.jwtToken) {
        this.setState({
          user: null,
          jwtToken: null
        });
      }
    }
  }, {
    key: "fetchEyebrowPromo",
    value: function fetchEyebrowPromo() {
      var _this3 = this;

      var brandType = this.state.brandType;

      if (!this.state.eyebrowPromoData.__html && typeof document !== 'undefined') {
        // Bob server might provide the promo DC as part of the SSR HTML.
        // If found, short circuit the whole process.
        try {
          var bobSsr = document.querySelector('#univeral-header-promo-ssr');

          if (bobSsr) {
            var html = bobSsr.innerHTML; // Erase from DOM, no longer needed there.

            bobSsr.innerHTML = '';
            this.setState({
              eyebrowPromoData: {
                __html: html
              },
              isFetchEyebrowApiDone: true
            });
            return;
          }
        } catch (err) {
          console.error(err);
        }

        var invalidCachedTime = this.props.invalidCachedTimeEyeBrow;
        var eyeBrow = this.props.enableLocalStorageCached ? (0, _helperUtil.getDataFromLocalStorage)((0, _helperUtil.getLocalStorageEyeBrowKey)(brandType), invalidCachedTime) : null;

        if (eyeBrow) {
          this.markInfo('Universal Header: Fetched eyebrow details from cache');
          this.setState({
            eyebrowPromoData: eyeBrow,
            isFetchEyebrowApiDone: true
          });
          return;
        }

        this.markInfo('Universal Header: Fetching eyebrow details using api call');
        var startTime = new Date().getTime();
        (0, _fetchEyebrowPromo2.default)(brandType === _constants.BRANDS.TINYPRINTS ? this.props.tpEyebrowDcName : this.props.sflyEyebrowDcName).then(function (respData) {
          if (respData) {
            if (_this3.props.enableLocalStorageCached) {
              (0, _helperUtil.setDataToLocalStorage)((0, _helperUtil.getLocalStorageEyeBrowKey)(brandType), respData);
            }

            var timeDiff = new Date().getTime() - startTime;

            _this3.markInfo('Universal Header:[SUCCESS] Fetched eyebrow details using api call');

            _this3.markInfo('Universal Header: Required time to fetch eyebrow details using api call ', timeDiff + ' ms ');

            _this3.setState({
              eyebrowPromoData: respData,
              isFetchEyebrowApiDone: true
            });
          } else {
            _this3.markInfo('Universal Header:[FAILED] Fetched eyebrow details using api call');

            _this3.setState({
              isFetchEyebrowApiDone: true
            });
          }
        });
      }
    }
  }, {
    key: "toggleMenu",
    value: function toggleMenu() {
      var _this4 = this;

      this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      }, function () {
        _this4.toggleBackScreenFocus(_this4.state.isOpen);
      });
    }
  }, {
    key: "getCurrentUser",
    value: function () {
      var _getCurrentUser = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(params) {
        var _this5 = this;

        var initAuth, _ref, jwtToken;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(typeof window === 'undefined')) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                _context3.prev = 2;

                if (window.$sflyAuth) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 6;
                return (0, _uigCdnLibraries.loadSflyAuth)();

              case 6:
                initAuth = _context3.sent;
                _context3.next = 9;
                return initAuth();

              case 9:
                _context3.next = 12;
                break;

              case 11:
                if (window.$sflyAuth.currentUser) {
                  this.setState({
                    user: window.$sflyAuth.currentUser
                  });
                }

              case 12:
                _context3.next = 14;
                return window.$sflyAuth.getIdToken();

              case 14:
                _ref = _context3.sent;
                jwtToken = _ref.jwtToken;

                if (jwtToken) {
                  this.setState({
                    user: window.$sflyAuth.getCurrentUser(),
                    jwtToken: jwtToken
                  }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
                    var projectCnt;
                    return _regenerator.default.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return (0, _fetchMyProjectData.default)(jwtToken, _this5.state.user);

                          case 2:
                            projectCnt = _context2.sent;
                            console.log("projectCnt", projectCnt);

                            _this5.setState({
                              projectCnt: projectCnt
                            });

                          case 5:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  })));
                }

                _context3.next = 21;
                break;

              case 19:
                _context3.prev = 19;
                _context3.t0 = _context3["catch"](2);

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 19]]);
      }));

      function getCurrentUser(_x) {
        return _getCurrentUser.apply(this, arguments);
      }

      return getCurrentUser;
    }()
  }, {
    key: "updateSkipLinks",
    value: function updateSkipLinks() {
      if (this.skipLinks && this.skipLinks.current) {
        this.skipLinks.current.update();
      }
    }
  }, {
    key: "handleUHResizeMode",
    value: function handleUHResizeMode() {
      var isOpen = this.state.isOpen;

      if (!this.isBackScreenFocusable && typeof window !== 'undefined' && window.innerWidth >= 992) {
        this.toggleBackScreenFocus(isOpen, true);
      } else if (this.isBackScreenFocusable && this.state.isOpen && typeof window !== 'undefined' && window.innerWidth < 992) {
        this.toggleBackScreenFocus(isOpen, false);
      }
    }
  }, {
    key: "toggleBackScreenFocus",
    value: function toggleBackScreenFocus(isHamburgerMenuOpen, isBackScreenFocusEnabled) {
      var backScreenElements = typeof document !== 'undefined' && document.querySelectorAll('main ,footer');

      if (backScreenElements && backScreenElements.length > 0) {
        for (var index = 0; index < backScreenElements.length; index++) {
          var displayValue = isBackScreenFocusEnabled ? "block" : isHamburgerMenuOpen ? "none" : "block";
          backScreenElements[index].style.display = displayValue;
          this.isBackScreenFocusable = isBackScreenFocusEnabled || !isHamburgerMenuOpen;
        }
      }

      if (!isHamburgerMenuOpen) {
        this.focusHamburgerButton();
      }
    }
  }, {
    key: "focusHamburgerButton",
    value: function focusHamburgerButton() {
      if (typeof document === 'undefined') {
        return;
      }

      var hamburgerButton = document.querySelector('.uig-responsive-header-menu');

      if (hamburgerButton) {
        hamburgerButton.focus();
      }
    }
  }, {
    key: "handleHeaderKeyDown",
    value: function handleHeaderKeyDown(e) {
      if (this.state.isOpen && (e.key === 'Escape' || e.key === 'Esc')) {
        e.preventDefault();
        this.toggleMenu();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var menuStatus = this.state.isOpen ? 'isOpen' : 'isClose';
      var _this$props = this.props,
          signinForwardUrl = _this$props.signinForwardUrl,
          signupForwardUrl = _this$props.signupForwardUrl,
          history = _this$props.history;
      var _this$state = this.state,
          brandType = _this$state.brandType,
          projectCnt = _this$state.projectCnt,
          isSpoonflowerDayOneEnabled = _this$state.isSpoonflowerDayOneEnabled;
      var signUpUrlBasedOnReferrer = _constants.BRANDS.SHUTTERFLY === this.props.brandType && typeof window !== 'undefined' && window.location.pathname === '/' ? signupForwardUrl : window.location.href;
      var brandForLogo = this.props.brandType === _constants.BRANDS.SHUTTERFLY || this.props.brandType === _constants.BRANDS.TINYPRINTS ? this.props.brandType : _constants.BRANDS.INC;
      brandForLogo = this.props.brandType === 'WPD' ? _constants.BRANDS.SHUTTERFLY : brandForLogo;
      var brandClass = 'brand-inc';
      var fromStateUserName = this.state.user && this.state.user.given_name ? this.state.user.given_name : '';
      var userFirstName = this.props.userFirstName ? this.props.userFirstName : fromStateUserName;

      if (brandForLogo === _constants.BRANDS.SHUTTERFLY) {
        brandClass = 'brand-sfly';
      } else if (brandForLogo === _constants.BRANDS.TINYPRINTS) {
        brandClass = 'brand-tp brand-TP';
      } // Construct a list of potential class names for the main element


      var classNameList = ['uig-universal-wrapper'];

      if (this.state.isOpen) {
        classNameList.push('isOpenHamburger');
      }

      if (this.props.hideNavbar) {
        classNameList.push('extraMarginBottom');
      }

      if (this.props.additionalClassNames.length > 0) {
        classNameList = classNameList.concat(this.props.additionalClassNames);
      }

      return _react.default.createElement("header", {
        onKeyDown: this.handleHeaderKeyDown,
        className: classNameList.join(' ')
      }, _react.default.createElement(_SkipLinks.default, {
        ref: this.skipLinks,
        brandType: brandForLogo
      }), _react.default.createElement("div", {
        className: "uig-toolbar-wrapper ".concat(brandClass)
      }, _react.default.createElement(_LogoTabs.default // sflySpecialOccasions={this.props.sflySpecialOccasions}
      , {
        tpSpecialOccasions: this.props.tpSpecialOccasions,
        currentBrand: brandForLogo,
        showUnselectedLogo: this.props.showUnselectedLogo,
        enableLink: true,
        isSpoonflowerDayOneEnabled: isSpoonflowerDayOneEnabled
      }), !this.props.hideToolbar && _react.default.createElement(_PersonalToolbar.default, {
        jwtToken: this.state.jwtToken,
        user: this.state.user,
        userFirstName: userFirstName,
        currentBrand: brandForLogo,
        ssoTheme: this.props.ssoTheme,
        signinForwardUrl: decodeURIComponent(signinForwardUrl),
        signupForwardUrl: decodeURIComponent(signUpUrlBasedOnReferrer),
        extraDropdownOptions: this.props.extraDropdownOptions,
        activeLink: this.props.activeLink,
        history: history,
        projectCnt: projectCnt
      }, _react.default.createElement(_Hamburger.default, {
        isOpen: this.state.isOpen,
        callback: function callback(isOpen) {
          return _this6.toggleMenu(isOpen);
        }
      }))), _react.default.createElement("div", {
        className: "uig-nav-bar-wrapper ".concat(brandType === _constants.BRANDS.TINYPRINTS ? 'brand-TP' : '', " ")
      }, !this.props.hideNavbar && !this.state.isOpen && _react.default.createElement(_react.Fragment, null, _react.default.createElement(_uigBreakpoints.Media, {
        min: "md",
        render: function render() {
          return _react.default.createElement(_SubNavWrapper.default, {
            categoryCache: _this6.categoryCache,
            selectedCategoryId: _this6.state.selectedCategoryId,
            brandType: brandType,
            jwtToken: _this6.state.jwtToken,
            user: _this6.state.user
          });
        }
      }), !this.props.hideMobileNavbar && _react.default.createElement(_uigBreakpoints.Media, {
        max: "sm",
        render: function render() {
          return _react.default.createElement(_SubNavWrapperMobile.default, {
            categoryCache: _this6.categoryCache,
            selectedCategoryId: _this6.state.selectedCategoryId,
            brandType: brandType,
            jwtToken: _this6.state.jwtToken,
            user: _this6.state.user
          });
        }
      })), !this.props.hideToolbar && this.state.isOpen && _react.default.createElement("div", {
        className: "uig-responsive-menu-container ".concat(brandType === _constants.BRANDS.TINYPRINTS ? 'TP' : '', " ").concat(menuStatus, "-menu")
      }, _react.default.createElement(_uigBreakpoints.Media, {
        max: "md",
        render: function render() {
          return _react.default.createElement(_HamburgerMenuComponent.default, {
            categoryCache: _this6.categoryCache,
            brandType: brandType,
            menuStatus: menuStatus,
            isSpoonflowerDayOneEnabled: isSpoonflowerDayOneEnabled,
            user: _this6.state.user,
            userFirstName: userFirstName,
            jwtToken: _this6.state.jwtToken,
            extraDropdownOptions: _this6.props.extraDropdownOptions,
            signinForwardUrl: decodeURIComponent(signinForwardUrl),
            signupForwardUrl: decodeURIComponent(signUpUrlBasedOnReferrer),
            projectCnt: projectCnt
          });
        }
      }))), _react.default.createElement(_EyebrowPromo.default, {
        eyebrowPromoData: this.state.eyebrowPromoData,
        hideEyebrowPromo: this.props.hideNavbar || this.props.hideEyebrowPromo || this.state.isOpen,
        className: brandClass,
        useStickyEyebrow: this.props.useStickyEyebrow
      }));
    }
  }]);
  return UniversalHeader;
}(_react.Component);

exports.default = UniversalHeader;
UniversalHeader.propTypes = {
  brandType: _propTypes.default.string,
  ssoTheme: _propTypes.default.oneOf([_constants.SSO_THEMES.SHUTTERFLY, _constants.SSO_THEMES.TINYPRINTS, _constants.SSO_THEMES.INC, _constants.SSO_THEMES.LTI, _constants.SSO_THEMES.MLT, _constants.SSO_THEMES.PRESCHOOLS, _constants.SSO_THEMES.PRESTIGE]),
  extraDropdownOptions: _propTypes.default.array,
  activeLink: _propTypes.default.oneOf(['signIn', 'signedIn', 'myAccount', 'myPhotos', 'shareSites', 'cart', 'none']),
  useLocal: _propTypes.default.bool,
  enableLocalStorageCached: _propTypes.default.bool,
  enableMockData: _propTypes.default.bool,
  user: _propTypes.default.shape({
    firstName: _propTypes.default.string
  }),
  sflySpecialOccasions: _propTypes.default.string,
  tpSpecialOccasions: _propTypes.default.string,
  selectedCategoryId: _propTypes.default.string,
  showUnselectedLogo: _propTypes.default.bool,
  hideToolbar: _propTypes.default.bool,
  hideNavbar: _propTypes.default.bool,
  hideMobileNavbar: _propTypes.default.bool,
  sflyEyebrowDcName: _propTypes.default.string,
  tpEyebrowDcName: _propTypes.default.string,
  hideEyebrowPromo: _propTypes.default.bool,
  invalidCachedTimeCategories: _propTypes.default.any,
  invalidCachedTimeSubCategories: _propTypes.default.any,
  invalidCachedTimeEyeBrow: _propTypes.default.any,
  invalidCachedTimeSubnavConfig: _propTypes.default.any,
  signinForwardUrl: _propTypes.default.string,
  signupForwardUrl: _propTypes.default.string,
  userFirstName: _propTypes.default.string,
  useStickyEyebrow: _propTypes.default.bool,
  history: _propTypes.default.any,
  additionalClassNames: _propTypes.default.array
};
UniversalHeader.defaultProps = {
  brandType: _constants.BRANDS.SHUTTERFLY,
  ssoTheme: null,
  extraDropdownOptions: null,
  activeLink: 'none',
  selectedCategoryId: '',
  useLocal: false,
  enableLocalStorageCached: false,
  enableMockData: true,
  user: null,
  sflySpecialOccasions: '',
  tpSpecialOccasions: '',
  showUnselectedLogo: true,
  hideToolbar: false,
  hideNavbar: false,
  hideMobileNavbar: false,
  sflyEyebrowDcName: 'home_prospect_promo_cs',
  tpEyebrowDcName: 'tp_eyebrow_promo',
  hideEyebrowPromo: false,
  invalidCachedTimeCategories: 1440,
  // 24hr validCachedTime
  invalidCachedTimeSubCategories: 60,
  //1hr validCachedTime
  invalidCachedTimeEyeBrow: 60,
  //1hr validCachedTime
  invalidCachedTimeSubnavConfig: 60,
  signinForwardUrl: typeof window !== 'undefined' ? window.location.href : '',
  signupForwardUrl: URL_SIGN_UP,
  userFirstName: '',
  useStickyEyebrow: true,
  history: null,
  additionalClassNames: []
};